import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3120f32d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tasks-table" }
const _hoisted_2 = {
  key: 0,
  class: "tasks-table__group"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "tasks-table__group-title tasks-table__group-title--in-progress" }, " Currently In Progress ", -1))
const _hoisted_4 = { class: "tasks-table__badges" }
const _hoisted_5 = { class: "tasks-table__actions" }
const _hoisted_6 = { class: "tasks-table__group-title" }
const _hoisted_7 = { class: "tasks-table__badges" }
const _hoisted_8 = { class: "tasks-table__actions" }

import type { QTableProps } from 'quasar';
import { ref, computed } from 'vue';
import { groupBy, orderBy } from 'lodash';

import DeleteTaskModal from '@/components/tasks/partials/DeleteTaskModal.vue';
import EditTaskModal from '@/components/tasks/partials/EditTaskModal.vue';

import DSTable from '@/design-system/DSTable.vue';
import DSButton from '@/design-system/DSButton.vue';
import DSBadge from '@/design-system/DSBadge.vue';

import { useStore } from '@/store';

import TaskInterface from '@/interfaces/Task.interface';
import formatTimer from '@/hooks/formatTimer';

import { CREATE_TASK_SESSION, FINISH_TASK_SESSION, SET_ACTIVE_TASK } from '@/store/types/actions';
import { NEW_ACTIVE_TASK } from '@/store/types/mutations';


export default /*#__PURE__*/_defineComponent({
  __name: 'TasksTable',
  setup(__props) {

const store = useStore();
const selected_task = ref({} as TaskInterface);
const deleteTaskModal = ref(DeleteTaskModal);
const editTaskModal = ref(EditTaskModal);

const tasks = computed(() => store.state.task.tasks);

const columns: QTableProps['columns'] = [
  {
    name: 'continue',
    align: 'left',
    style: 'width: 80px',
    label: '',
    field: '',
  },
  {
    name: 'description',
    required: true,
    label: 'Task',
    align: 'left',
    field: 'description',
    sortable: true,
    style: 'min-width: 150px',
  },
  {
    name: 'project',
    align: 'left',
    style: 'width: 200px',
    label: 'Project',
    field: '',
  },
  {
    name: 'total_time_spent',
    label: 'Time spent',
    align: 'left',
    style: 'width: 130px',
    field: '',
  },
  {
    name: 'actions',
    align: 'right',
    style: 'width: 160px',
    label: '',
    field: '',
  },
];

const request_pending = ref([] as number[]);

const isRequestPending = (task: TaskInterface) => {
  return request_pending.value.includes(task.id);
};

const handleTask = async (task: TaskInterface) => {
  if (task.lastSessionStartedAt) {
    await store.dispatch(FINISH_TASK_SESSION, task);
    return store.commit(NEW_ACTIVE_TASK, {});
  }

  const new_task = await store.dispatch(CREATE_TASK_SESSION, task);
  await store.dispatch(SET_ACTIVE_TASK, new_task);
};

const handleInitTask = async (task: TaskInterface) => {
  request_pending.value.push(task.id);
  await handleTask(task);
  request_pending.value = request_pending.value.filter((task_id: string | number) => task_id !== task.id);
};

const getTaskIcon = (task: TaskInterface) => {
  return task.lastSessionStartedAt ? 'pause' : 'play_arrow';
};

const getTaskTime = (task: TaskInterface) => {
  return task.total_time_spent || task.time_spent || 0;
};

const selectTask = (task: TaskInterface) => {
  editTaskModal.value.openModal(task);
};

const tasksInProgress = computed(() => {
  return orderBy(
    tasks.value.filter((task: TaskInterface) => task.lastSessionStartedAt),
    ['createdAt', 'id'],
    ['desc', 'desc']
  );
});

const getTasksByDate = computed(() => {
  const day = (task: TaskInterface) => new Date(task.createdAt || (+task.id)).toDateString();
  return Object.entries(
    groupBy(
      orderBy(
        tasks.value.filter((task: TaskInterface) => !task.lastSessionStartedAt),
        ['createdAt', 'id'],
        ['desc', 'desc']
      ),
      day
    )
  );
});

const handleDeleteButtonClick = (task: TaskInterface) => {
  deleteTaskModal.value.openModal(task);
};

const getProjectVariant = (index: number): 'primary' | 'secondary' | 'success' | 'warning' => {
  const variants: Array<'primary' | 'secondary' | 'success' | 'warning'> = ['primary', 'secondary', 'success', 'warning'];
  return variants[index % variants.length];
};

return (_ctx: any,_cache: any) => {
  const _component_q_td = _resolveComponent("q-td")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (tasksInProgress.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(DSTable, {
              rows: tasksInProgress.value,
              columns: columns,
              loading: false,
              "rows-per-page-options": [0],
              dense: "",
              "sticky-header": "",
              "max-height": '400px',
              class: "tasks-table__table"
            }, {
              "body-cell-continue": _withCtx((props) => [
                _createVNode(_component_q_td, { props: props }, {
                  default: _withCtx(() => [
                    _createVNode(DSButton, {
                      loading: isRequestPending(props.row),
                      icon: getTaskIcon(props.row),
                      variant: "ghost",
                      size: "sm",
                      class: "tasks-table__action-btn",
                      onClick: ($event: any) => (handleInitTask(props.row)),
                      "aria-label": "Play/Pause task"
                    }, null, 8, ["loading", "icon", "onClick"])
                  ]),
                  _: 2
                }, 1032, ["props"])
              ]),
              "body-cell-project": _withCtx((props) => [
                _createVNode(_component_q_td, { props: props }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      (props.row.project?.name)
                        ? (_openBlock(), _createBlock(DSBadge, {
                            key: 0,
                            label: props.row.project.name,
                            variant: getProjectVariant(0),
                            size: "sm",
                            class: "tasks-table__project-badge"
                          }, null, 8, ["label", "variant"]))
                        : (_openBlock(), _createBlock(DSBadge, {
                            key: 1,
                            label: "No project",
                            variant: "info",
                            size: "sm",
                            outline: ""
                          }))
                    ])
                  ]),
                  _: 2
                }, 1032, ["props"])
              ]),
              "body-cell-actions": _withCtx((props) => [
                _createVNode(_component_q_td, { props: props }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(DSButton, {
                        icon: "edit",
                        variant: "secondary",
                        size: "sm",
                        class: "tasks-table__action-btn",
                        onClick: ($event: any) => (selectTask(props.row)),
                        "aria-label": "Edit task"
                      }, null, 8, ["onClick"]),
                      _createVNode(DSButton, {
                        icon: "delete",
                        variant: "danger",
                        size: "sm",
                        class: "tasks-table__action-btn",
                        onClick: ($event: any) => (handleDeleteButtonClick(props.row)),
                        "aria-label": "Delete task"
                      }, null, 8, ["onClick"])
                    ])
                  ]),
                  _: 2
                }, 1032, ["props"])
              ]),
              "body-cell-total_time_spent": _withCtx((props) => [
                _createVNode(_component_q_td, { props: props }, {
                  default: _withCtx(() => [
                    _createVNode(DSBadge, {
                      label: _unref(formatTimer)(getTaskTime(props.row)),
                      variant: "primary",
                      size: "sm"
                    }, null, 8, ["label"])
                  ]),
                  _: 2
                }, 1032, ["props"])
              ]),
              _: 1
            }, 8, ["rows"])
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getTasksByDate.value, (tasks_aggregate, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "tasks-table__group"
        }, [
          _createElementVNode("h3", _hoisted_6, _toDisplayString(tasks_aggregate[0]), 1),
          _createVNode(DSTable, {
            rows: tasks_aggregate[1],
            columns: columns,
            loading: false,
            "rows-per-page-options": [0],
            dense: "",
            "sticky-header": "",
            "max-height": '400px',
            class: "tasks-table__table"
          }, {
            "body-cell-continue": _withCtx((props) => [
              _createVNode(_component_q_td, { props: props }, {
                default: _withCtx(() => [
                  _createVNode(DSButton, {
                    loading: isRequestPending(props.row),
                    icon: getTaskIcon(props.row),
                    variant: "ghost",
                    size: "sm",
                    class: "tasks-table__action-btn",
                    onClick: ($event: any) => (handleInitTask(props.row)),
                    "aria-label": "Play/Pause task"
                  }, null, 8, ["loading", "icon", "onClick"])
                ]),
                _: 2
              }, 1032, ["props"])
            ]),
            "body-cell-project": _withCtx((props) => [
              _createVNode(_component_q_td, { props: props }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    (props.row.project?.name)
                      ? (_openBlock(), _createBlock(DSBadge, {
                          key: 0,
                          label: props.row.project.name,
                          variant: getProjectVariant(0),
                          size: "sm",
                          class: "tasks-table__project-badge"
                        }, null, 8, ["label", "variant"]))
                      : (_openBlock(), _createBlock(DSBadge, {
                          key: 1,
                          label: "No project",
                          variant: "info",
                          size: "sm",
                          outline: ""
                        }))
                  ])
                ]),
                _: 2
              }, 1032, ["props"])
            ]),
            "body-cell-actions": _withCtx((props) => [
              _createVNode(_component_q_td, { props: props }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(DSButton, {
                      icon: "edit",
                      variant: "secondary",
                      size: "sm",
                      class: "tasks-table__action-btn",
                      onClick: ($event: any) => (selectTask(props.row)),
                      "aria-label": "Edit task"
                    }, null, 8, ["onClick"]),
                    _createVNode(DSButton, {
                      icon: "delete",
                      variant: "danger",
                      size: "sm",
                      class: "tasks-table__action-btn",
                      onClick: ($event: any) => (handleDeleteButtonClick(props.row)),
                      "aria-label": "Delete task"
                    }, null, 8, ["onClick"])
                  ])
                ]),
                _: 2
              }, 1032, ["props"])
            ]),
            "body-cell-total_time_spent": _withCtx((props) => [
              _createVNode(_component_q_td, { props: props }, {
                default: _withCtx(() => [
                  _createVNode(DSBadge, {
                    label: _unref(formatTimer)(getTaskTime(props.row)),
                    variant: "primary",
                    size: "sm"
                  }, null, 8, ["label"])
                ]),
                _: 2
              }, 1032, ["props"])
            ]),
            _: 2
          }, 1032, ["rows"])
        ]))
      }), 128))
    ]),
    _createVNode(DeleteTaskModal, {
      ref_key: "deleteTaskModal",
      ref: deleteTaskModal,
      task: selected_task.value
    }, null, 8, ["task"]),
    _createVNode(EditTaskModal, {
      ref_key: "editTaskModal",
      ref: editTaskModal,
      task: selected_task.value
    }, null, 8, ["task"])
  ], 64))
}
}

})